<template>
  <div class="group-by">
    <h3 class="margin-0">{{ t('division-into').toUpperCase() }}</h3>

    <select
        class="form-select"
        name="groupBy"
        v-model.lazy="value"
        :disabled="store.disabledFields?.division"
    >
      <option
          v-for="opt in options"
          :key="opt.key"
          :value="opt.key"
      >
        {{ t(opt.labelKey) }}
      </option>
    </select>
  </div>
</template>

<script>
import { watch, ref, computed } from "vue";
import { isSG } from "@/config/appVersion";

export default {
  props: {
    store: { required: true },
  },
  name: "GroupByFilter",
  setup(props) {
    const allowedKeys = computed(() => (isSG ? ["lane", "violation"] : null));

    const options = computed(() => {
      const base = props.store.groupBy || {};
      const keys = Object.keys(base);

      const filteredKeys = allowedKeys.value
          ? keys.filter((k) => allowedKeys.value.includes(k))
          : keys;

      return filteredKeys.map((k) => ({
        key: k,
        labelKey: base[k], // np. "lane" / "violation" -> klucz tłumaczenia
      }));
    });

    // inicjalna wartość
    const value = ref(props.store.filters.groupBy);

    // jeśli SG i obecna wartość jest niedozwolona -> ustaw na "lane"
    const ensureValidSelection = () => {
      if (!isSG) return;

      const allowed = allowedKeys.value || [];
      if (!value.value || !allowed.includes(value.value)) {
        const fallback = allowed[0] || "lane";
        value.value = fallback;
        props.store.addItem("groupBy", fallback);
      }
    };

    ensureValidSelection();

    // zapis do store przy zmianie
    watch(value, (newValue) => {
      if (isSG) {
        const allowed = allowedKeys.value || [];
        if (!allowed.includes(newValue)) {
          // twarda blokada (nie zapisuj niedozwolonych)
          const fallback = allowed[0] || "lane";
          value.value = fallback;
          props.store.addItem("groupBy", fallback);
          return;
        }
      }
      props.store.addItem("groupBy", newValue);
    });

    // gdy store się zmieni z zewnątrz (np. preselect tab), też pilnuj poprawności
    watch(
        () => props.store.filters.groupBy,
        (newKey) => {
          value.value = newKey;
          ensureValidSelection();
        }
    );

    return { value, options };
  },
};
</script>

<style scoped>
.group-by {
  width: 50%;
  min-height: 140px;
}
.group-by h3 {
  padding: 10px 15px 5px;
  width: 100%;
  border-right: 1px solid #e1e1df;
}
.group-by select {
  height: 30px;
  margin-top: 6px;
  font-size: 12px;
}
</style>
